import { Dialog, Transition } from "@headlessui/react";
import React, { Fragment, useEffect, useRef } from "react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { usePaymentDebitNoteDetailsAPI } from "@/app/hooks/api_hooks/payment/usePaymentDebitNoteDetailsAPI";
import { useUtils } from "@/app/hooks/useUtils";

type Props = {
  open: boolean;
  setOpen: (value: boolean) => void;
  debitnoteid: string;
};

const ViewDebitNoteModalComponent: React.FC<Props> = ({ open, setOpen, debitnoteid }) => {
  const cancelButtonRef = useRef(null);
  const { epocToDateTimeForNumberDDMMYY } = useUtils();
  const { execute: fetchDetbitNote, debitNoteData } = usePaymentDebitNoteDetailsAPI();

  useEffect(() => {
    fetchDetbitNote(debitnoteid);
  }, [debitnoteid]);

  return (
    <div>
      <Transition.Root show={open} as={Fragment}>
        <Dialog
          as="div"
          className="fixed inset-0 z-50 overflow-y-auto"
          initialFocus={cancelButtonRef}
          onClose={() => {
            setOpen(false);
          }}
        >
          <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75" />
            </Transition.Child>

            <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
              &#8203;
            </span>

            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <div className="inline-block align-bottom bg-white rounded-lg text-left  overflow-visible  shadow-xl transform transition-all sm:my-8 sm:align-middle sm:w-full sm:max-w-3xl">
                <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                  <div className="flex justify-between items-center mt-2">
                    <h2 className="text-sm font-medium">Debit Note Details</h2>
                    <span
                      onClick={() => {
                        setOpen(false);
                      }}
                    >
                      <XMarkIcon className="h-4 w-4 cursor-pointer" />
                    </span>
                  </div>
                  <div className="flex items-center pt-5 ">
                    <div className=" items-start flex  w-3/12">
                      <p>Debit Note ID</p>
                    </div>
                    <p className="font-medium text-[#000000]">{debitNoteData?.debit_note_receipt_id}</p>
                  </div>
                  <div className="flex items-center pt-5">
                    <div className=" items-start flex w-3/12 ">
                      <p>Credit Note ID</p>
                    </div>
                    <div className="flex flex-col   ">
                      <p className="font-medium text-[#000000]">{debitNoteData?.credit_note_receipt_id}</p>
                    </div>
                  </div>
                  <div className="flex items-center pt-5">
                    <div className=" items-start flex w-3/12 ">
                      <p>Amount</p>
                    </div>
                    <div className="flex flex-col   ">
                      <p className="font-medium text-[#000000]">{debitNoteData?.debit_amount}</p>
                    </div>
                  </div>
                  <div className="flex items-center pt-5">
                    <div className=" items-start flex w-3/12 ">
                      <p>Date</p>
                    </div>
                    <div className="flex flex-col   ">
                      <p className="font-medium text-[#000000]">
                        {epocToDateTimeForNumberDDMMYY(debitNoteData?.created_at)}
                      </p>
                    </div>
                  </div>

                  <div className="flex items-center pt-5 ">
                    <div className=" items-start flex w-3/12">
                      <p>Comment</p>
                    </div>
                    <div className="flex flex-col   ">
                      <p className="font-medium text-[#000000]">{debitNoteData?.comments}</p>
                    </div>
                  </div>
                </div>
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition.Root>
    </div>
  );
};

export default ViewDebitNoteModalComponent;
